import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#1a0d2e] py-16 px-4" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <div className="text-center mb-10" data-id="element-75">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-76">
            🕊️ ¿QUÉ AGREGA EL MANUAL DE{' '}
            <span className="text-[#A855F7]" data-id="element-77">POSTUROLOGÍA EXPERTA</span>?
          </h2>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#A855F7]/30 rounded-2xl overflow-hidden mb-12" data-id="element-78">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#0d0818] border-b border-[#A855F7]/30" data-id="element-79">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-80">
              Situación en el estudio
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#A855F7]/30" data-id="element-81">
              ❌ Sin el Manual
            </div>
            <div className="p-4 font-bold text-[#A855F7] text-center border-l border-[#A855F7]/30" data-id="element-82">
              ✅ Con el Manual
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-83">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-84">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-85">
                Situación:
              </span>
              Llega un alumno con espondilolistesis
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-87">
                ❌ Sin el Manual:
              </span>
              No sabés si podés trabajar
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#A855F7]/5" data-id="element-88">
              <span className="sm:hidden font-bold text-[#A855F7] block mb-1" data-id="element-89">
                ✅ Con el Manual:
              </span>
              Protocolo específico listo. Criterio claro.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-90">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-91">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-92">
                Situación:
              </span>
              Alumno con fibromialgia pregunta si puede hacer Pilates
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-94">
                ❌ Sin el Manual:
              </span>
              Improvisás una respuesta
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#A855F7]/5" data-id="element-95">
              <span className="sm:hidden font-bold text-[#A855F7] block mb-1" data-id="element-96">
                ✅ Con el Manual:
              </span>
              Sabés exactamente qué sí, qué no y cómo progresarlo
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-97">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-98">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-99">
                Situación:
              </span>
              Querés justificar un aumento de precio
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-101">
                ❌ Sin el Manual:
              </span>
              No tenés argumento diferencial
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#A855F7]/5" data-id="element-102">
              <span className="sm:hidden font-bold text-[#A855F7] block mb-1" data-id="element-103">
                ✅ Con el Manual:
              </span>
              Tarifa de especialista con criterio documentado
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-104">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-105">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-106">
                Situación:
              </span>
              Un médico te pide un informe de evolución
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-108">
                ❌ Sin el Manual:
              </span>
              No sabés qué escribir
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#A855F7]/5" data-id="element-109">
              <span className="sm:hidden font-bold text-[#A855F7] block mb-1" data-id="element-110">
                ✅ Con el Manual:
              </span>
              Template profesional listo para firmar
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-111">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-112">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-113">
                Situación:
              </span>
              Querés que los médicos te deriven
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-114">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-115">
                ❌ Sin el Manual:
              </span>
              No sabés cómo acercarte
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#A855F7]/5" data-id="element-116">
              <span className="sm:hidden font-bold text-[#A855F7] block mb-1" data-id="element-117">
                ✅ Con el Manual:
              </span>
              Sistema completo de networking clínico
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-118">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-119">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-120">
                Situación:
              </span>
              Un alumno tiene SHA hiperlaxitud
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-121">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-122">
                ❌ Sin el Manual:
              </span>
              No conocés el diagnóstico
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#A855F7]/5" data-id="element-123">
              <span className="sm:hidden font-bold text-[#A855F7] block mb-1" data-id="element-124">
                ✅ Con el Manual:
              </span>
              Protocolo específico — la paradoja que salva la clase
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-125">
          ✅ EL MANUAL INCLUYE:
        </h3>

        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-126">
          <span className="bg-black border border-[#A855F7]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-127">
            5 cadenas miofasciales aplicadas
          </span>
          <span className="bg-black border border-[#A855F7]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-128">
            Evaluación postural en 4 fases
          </span>
          <span className="bg-black border border-[#A855F7]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-129">
            6 patologías con protocolos
          </span>
          <span className="bg-black border border-[#A855F7]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-130">
            Template de informe médico
          </span>
          <span className="bg-black border border-[#A855F7]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-131">
            Marketing clínico y tarifas
          </span>
          <span className="bg-black border border-[#A855F7]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-132">
            Red de derivaciones médicas
          </span>
          <span className="bg-black border border-[#A855F7]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-133">
            Lista de ejercicios prohibidos
          </span>
          <span className="bg-black border border-[#A855F7]/40 text-white text-sm font-semibold px-4 py-2 rounded-full" data-id="element-134">
            Certificado de autoridad
          </span>
        </div>
      </div>
    </section>;
}